import { MyLink } from '@ui-kit/Link';
import Image from 'next/image';

export const LogoGif = ({ width, height }: { width: number; height: number }) => {
  return (
    <MyLink href="/" data-testid="header-logo">
      <Image src={'/next/late-2024.gif'} width={width} height={height} priority={true} layout={'fixed'} alt={'logo'} />
    </MyLink>
  );
};
